import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 login-page" }
const _hoisted_2 = { class: "main_content_iner" }
const _hoisted_3 = { class: "container-fluid p-0" }
const _hoisted_4 = { class: "row mx-0 justify-content-center" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "mb_30 mt_30" }
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-lg-5 col-xl-4 mt-4" }
const _hoisted_9 = { class: "white_card mb_30 shadow-sm p-5 bg-light border" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger mb-4",
  role: "alert"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" }),
  /*#__PURE__*/_createTextVNode(" Email")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }),
  /*#__PURE__*/_createTextVNode(" Password")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#forgotPassword"
}, "Forgot password", -1)
const _hoisted_14 = { class: "text-center d-grid gap-2 mt-2" }
const _hoisted_15 = { class: "btn btn-primary btn-block rounded-5 my-3 text-uppercase" }
const _hoisted_16 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ForgotPasswordModal = _resolveComponent("ForgotPasswordModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.wrong_credentials)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " You have entered an invalid username or password. "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Form, { onSubmit: _ctx.SignIn }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Field, {
                          name: "email",
                          rules: { required: true, email: true },
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                        }, {
                          default: _withCtx(({ field, meta }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid ? 'has-error border-danger' : ''])
                            }, [
                              _hoisted_11,
                              _createElementVNode("input", _mergeProps(field, {
                                type: "text",
                                id: "email",
                                placeholder: " ",
                                class: "form-control",
                                autocomplete: "off"
                              }), null, 16),
                              _createVNode(_component_ErrorMessage, {
                                class: "text-danger",
                                name: "email"
                              })
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_Field, {
                          name: "password",
                          rules: { required: true, min:5 },
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                        }, {
                          default: _withCtx(({ field, meta }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid ? 'has-error border-danger' : ''])
                            }, [
                              _hoisted_12,
                              _createElementVNode("input", _mergeProps(field, {
                                type: "password",
                                id: "password",
                                placeholder: " ",
                                class: "form-control",
                                autocomplete: "off"
                              }), null, 16),
                              _createVNode(_component_ErrorMessage, {
                                class: "text-danger",
                                name: "password"
                              })
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", _hoisted_15, [
                            (_ctx.logging)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_17
                                ], 64))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["onSubmit"]),
                    _createVNode(_component_ForgotPasswordModal)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}